/** Tabs of the event page, in display order. One tab set for every screen size. */
export const EVENT_TABS = ['settings', 'guests', 'send-emails', 'check-in'] as const;
export type EventTabKey = (typeof EVENT_TABS)[number];
export const EVENT_TAB_LABELS: Record<EventTabKey, string> = {
  settings: 'Réglages',
  guests: 'Invités',
  'send-emails': 'Envoi emails',
  'check-in': 'Check-in',
};
/** The page opens on Invités. */
export const DEFAULT_EVENT_TAB: EventTabKey = 'guests';
export const DEFAULT_EVENT_TAB_INDEX = EVENT_TABS.indexOf(DEFAULT_EVENT_TAB);

/** Front desk (viewer, #71): the check-in tab only. Everyone else gets every tab. */
export const eventTabsFor = (role?: string): EventTabKey[] =>
  role === 'viewer' ? ['check-in'] : [...EVENT_TABS];
export const defaultEventTabIndexFor = (role?: string): number => {
  const tabs = eventTabsFor(role);
  const i = tabs.indexOf(DEFAULT_EVENT_TAB);
  return i >= 0 ? i : 0;
};
